// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_containerTitle__kgT3j {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

.styles_title__gB52Q {
  align-items: center;
  color: #18316e !important;
  display: flex;
  font-size: 1.5rem;
  font-weight: bold;
  gap: 0.5rem;
}

.styles_containerVersao__q6jLe {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.styles_itemVersao__H7icu {
  align-items: center;
  border-radius: 5px;
  box-shadow: 1px 1px 5px #c6c6c6;
  display: flex;
  justify-content: space-between;
  padding: 0.3rem 0.6rem;
}

.styles_containerBtn__uNQKl {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
}

.styles_btnGerar__WRZxj {
  background: #18316e !important;
}

.styles_btnGerar__WRZxj:hover {
  background: #204091 !important;
}

.styles_btnFechar__Gen8F {
  border-color: #18316e !important;
  color: #18316e !important;
}

.styles_btnSelecionar__09dRq {
  border-color: #18316e !important;
  color: #18316e !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Projeto/ModalVersoes/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B","sourcesContent":[".containerTitle {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n}\n\n.title {\n  align-items: center;\n  color: #18316e !important;\n  display: flex;\n  font-size: 1.5rem;\n  font-weight: bold;\n  gap: 0.5rem;\n}\n\n.containerVersao {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.itemVersao {\n  align-items: center;\n  border-radius: 5px;\n  box-shadow: 1px 1px 5px #c6c6c6;\n  display: flex;\n  justify-content: space-between;\n  padding: 0.3rem 0.6rem;\n}\n\n.containerBtn {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1.5rem;\n}\n\n.btnGerar {\n  background: #18316e !important;\n}\n\n.btnGerar:hover {\n  background: #204091 !important;\n}\n\n.btnFechar {\n  border-color: #18316e !important;\n  color: #18316e !important;\n}\n\n.btnSelecionar {\n  border-color: #18316e !important;\n  color: #18316e !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerTitle": `styles_containerTitle__kgT3j`,
	"title": `styles_title__gB52Q`,
	"containerVersao": `styles_containerVersao__q6jLe`,
	"itemVersao": `styles_itemVersao__H7icu`,
	"containerBtn": `styles_containerBtn__uNQKl`,
	"btnGerar": `styles_btnGerar__WRZxj`,
	"btnFechar": `styles_btnFechar__Gen8F`,
	"btnSelecionar": `styles_btnSelecionar__09dRq`
};
export default ___CSS_LOADER_EXPORT___;
